import { Loader2 } from "lucide-react"

import { cn } from "@/lib/utils"

type SpinnerProps = {
  className?: string
}

export const Spinner = ({ className }: SpinnerProps) => (
  <Loader2 className={cn("h-5 w-5 animate-spin text-primary", className)} />
)
